import { render, staticRenderFns } from "./ModalityPermissionsTable.vue?vue&type=template&id=360dfa74&scoped=true"
import script from "./ModalityPermissionsTable.vue?vue&type=script&lang=js"
export * from "./ModalityPermissionsTable.vue?vue&type=script&lang=js"
import style0 from "./ModalityPermissionsTable.vue?vue&type=style&index=0&id=360dfa74&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "360dfa74",
  null
  
)

export default component.exports